__webpack_require__.p = "https://cdn.leaguespot.gg/";